import React from 'react';
import { IconProps } from '../types';
const MinecraftNetheriteHoe: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="1" width="1" height="1" fill="rgba(74, 41, 62, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(74, 41, 62, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(74, 41, 62, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(74, 41, 62, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(134, 123, 134, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(134, 123, 134, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(134, 123, 134, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(74, 41, 62, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(112, 103, 112, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(134, 123, 134, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(50, 39, 39, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(47, 33, 34, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(96, 52, 50, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(93, 86, 93, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(112, 103, 112, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(115, 69, 67, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(47, 33, 34, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(93, 86, 93, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(79, 60, 62, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(47, 33, 34, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(96, 52, 50, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(47, 33, 34, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(115, 69, 67, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(47, 33, 34, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(96, 52, 50, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(47, 33, 34, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(115, 69, 67, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(47, 33, 34, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(67, 64, 67, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(47, 33, 34, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(59, 57, 59, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(47, 33, 34, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(67, 64, 67, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(47, 33, 34, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(115, 69, 67, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(27, 20, 21, 255)" />
</svg>);
export default MinecraftNetheriteHoe;